import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CatalogueTemplate } from 'src/app/models/bot/catalogue';
import { BotResourceService } from 'src/app/services/bot-resource.service';

@Component({
  selector: 'app-my-templates',
  templateUrl: './my-templates.component.html',
  styleUrls: ['./my-templates.component.css'],
})
export class MyTemplatesComponent implements OnInit {
  templates: CatalogueTemplate[] = [];
  loading = true;

  constructor(
    private botService: BotResourceService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.botService.listMyCatalogueTemplates().subscribe({
      next: (response) => {
        this.templates = response.items || [];
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      },
    });
  }

  statusLabel(status: string): string {
    switch (status) {
      case 'approved':
        return 'Approved';
      case 'pending':
        return 'Pending review';
      case 'denied':
        return 'Denied';
      case 'unlisted':
        return 'Unlisted';
      default:
        return status;
    }
  }

  open(template: CatalogueTemplate): void {
    this.router.navigate(['/templates', template.id]);
  }

  goCatalogue(): void {
    this.router.navigate(['/templates']);
  }
}
